import React from 'react';
import { Box, Button, Grid, MenuItem, TextField } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { TimeMask } from 'components';
import { convertMinutesToStringFormat } from 'utils';

interface ZoneScheduleTimeFormProps {
  minutes: number;
  onSubmit: (value: number) => void;
}

export const ZoneScheduleTimeForm = ({ minutes, onSubmit }: ZoneScheduleTimeFormProps) => {
  const formManager = useFormik({
    enableReinitialize: true,

    initialValues: {
      time: convertMinutesToStringFormat(minutes, false),
      am: minutes >= 720 ? 'pm' : 'am',
    },

    validationSchema: Yup.object({
      time: Yup.string().nullable().required('This value is required.'),
    }),

    onSubmit: (values) => {
      const { time, am } = values;

      // convert back into minutes.
      let [hours = 0, minutes = 0] = time.split(':').map((t) => parseInt(t, 10));

      if (am === 'pm' && hours !== 12) {
        hours += 12;
      }

      minutes += hours * 60;

      onSubmit(minutes);
    },
  });

  return (
    <Box sx={{ paddingY: 2 }}>
      <form onSubmit={formManager.handleSubmit}>
        <Grid container sx={{ alignItems: 'center' }} spacing={2}>
          <Grid item xs={10}>
            <TextField
              label="Time"
              variant="outlined"
              InputProps={{
                inputComponent: TimeMask as any,
              }}
              value={formManager.values.time || ''}
              onChange={formManager.handleChange('time')}
              error={!!(formManager.errors.time && formManager.touched.time)}
              helperText={formManager.touched.time ? formManager.errors.time : null}
            />

            <TextField
              select
              value={formManager.values.am || 'am'}
              onChange={formManager.handleChange('am')}
              sx={{ ml: 2 }}
            >
              {['am', 'pm'].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={2} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Button type="submit" startIcon={<Add />} sx={{ paddingX: 2 }}>
              Save
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};
